<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="16" viewBox="0 0 26 16" fill="none">
    <path d="M8.29389 0.710205L1.41431 7.58979L8.29389 14.4694" stroke="white" stroke-width="2"/>
    <path d="M17.5909 14.4663L24.4705 7.58673L17.5909 0.707147" stroke="white" stroke-width="2"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconSlide'
}
</script>
